module.exports = __webpack_public_path__ + "img/org-bfs-new.a9e8a147.jpg";